function profileInitial(name, fallback = '?') {
  const source = String(name ?? fallback).trim()
  return (source.charAt(0) || fallback).toUpperCase()
}

function ProfileAvatar({ photoUrl, name, size = 56 }) {
  const sizeClass = size === 64
    ? 'h-16 w-16 text-xl'
    : size === 36
    ? 'h-9 w-9 text-sm'
    : size === 44
    ? 'h-11 w-11 text-base'
    : 'h-14 w-14 text-lg'

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={`${sizeClass} shrink-0 rounded-full object-cover`}
        loading="eager"
        decoding="async"
      />
    )
  }

  return (
    <div
      className={`flex ${sizeClass} shrink-0 items-center justify-center rounded-full bg-accent font-semibold text-white`}
    >
      {profileInitial(name)}
    </div>
  )
}

export default ProfileAvatar
